export const FIELD_MAX = {
  org: { name: 120, description: 500 },
  role: { name: 100, description: 500 },
  user: {
    email: 320,
    username: 64,
    displayName: 200,
    jobTitle: 120,
    branch: 120,
    group: 120,
    ssn: 11,
    irsReportingName: 150,
    ownershipType: 60,
    ein: 10,
    businessPhone: 40,
    businessEmail: 150,
    bankRoutingNumber: 9,
    bankAccountNumber: 17,
    addressLine1: 200,
    city: 100,
    state: 50,
    zip: 20,
  },
  product: {
    name: 200,
    sku: 100,
    serialNumber: 200,
    modelNumber: 100,
    manufacturer: 200,
    barcode: 200,
    licenseKey: 500,
    description: 2000,
    notes: 2000,
  },
  salesCampaign: { name: 200, description: 500 },
  taxRate: { name: 200, location: 200 },
  appCampaign: {
    name: 200,
    acquirer: 200,
    tsysAssociation: 200,
    leadSource: 200,
    description: 500,
    acquiringFeeSpecialNote: 1000,
    achFeeSpecialNote: 1000,
  },
  appWizard: {
    dbaName: 23,
    legalName: 25,
    mcc: 4,
    email: 75,
    website: 40,
    ownershipType: 60,
    productDescription: 256,
    businessStartDate: 40,
    contactName: 51,
    phone: 14,
    addressLine1: 32,
    addressLine2: 10,
    city: 24,
    state: 2,
    zip: 10,
    dbaAddressLine1: 32,
    dbaCity: 24,
    dbaState: 2,
    dbaZip: 10,
    taxId: 32,
    taxIdType: 20,
    ein: 10,
    ssn: 11,
    bankName: 200,
    bankAccountNumber: 17,
    bankRoutingNumber: 9,
    depositAccountType: 50,
    withdrawBankName: 200,
    withdrawAccountType: 50,
    assocNumber: 50,
    salesRepCode: 50,
    pricingPlanOption: 50,
    pinDebitPlan: 50,
    batchCloseLocalTime: 10,
    ownerFirstName: 11,
    ownerMiddleName: 11,
    ownerLastName: 15,
    ownerTitle: 100,
    ownerDateOfBirth: 40,
    ownerSsn: 11,
    ownerPhone: 14,
    ownerHomeAddressLine1: 32,
    ownerHomeCity: 24,
    ownerHomeState: 2,
    ownerHomeZip: 10,
  },
  appPrincipal: {
    firstName: 11,
    middleName: 11,
    lastName: 15,
    title: 100,
    countryOfResidence: 100,
    ssn: 11,
    passportNumber: 25,
    homeAddress: 200,
    homeUnit: 5,
    homeCity: 24,
    homeState: 50,
    homeZip: 20,
    homePhone: 50,
    email: 320,
  },
  appBankAccount: {
    routingNumber: 9,
    accountNumber: 17,
    bankName: 200,
    bankPhone: 50,
    bankContact: 200,
  },
  appTradeReference: {
    tradeName: 25,
    accountNumber: 17,
    phone: 50,
    productSold: 25,
  },
  appPosSetup: {
    network: 100,
    posBrand: 100,
    posModel: 100,
    printerBrand: 100,
    printerModel: 100,
    industry: 100,
    applicationName: 200,
    integrationProductName: 200,
    packageOption: 100,
    packageType: 100,
    code: 20,
    billTo: 50,
  },
  ticket: { subject: 300, body: 20_000, templateName: 150, templateContent: 20_000 },
  quote: {
    customerName: 200,
    customerCompany: 200,
    customerEmail: 320,
    customerPhone: 50,
    customerAddress: 500,
    shippingName: 200,
    shippingCompany: 200,
    shippingEmail: 320,
    shippingPhone: 50,
    shippingAddress: 500,
    description: 500,
    notes: 2000,
    itemDescription: 500,
  },
  recurringInvoice: {
    profileName: 200,
    emailSubject: 500,
    orderNumber: 100,
    trackingNumber: 200,
    notes: 2000,
    itemDescription: 500,
  },
  merchant: {
    mid: 64,
    dbaName: 200,
    legalName: 200,
    mcc: 10,
    phone: 50,
    email: 320,
    contactName: 200,
    addressLine1: 200,
    addressLine2: 200,
    city: 100,
    state: 50,
    zip: 20,
    taxId: 64,
    ein: 32,
    ssn: 32,
    bankAccountNumber: 64,
    bankRoutingNumber: 32,
    notes: 4000,
  },
  merchantStore: {
    storeId: 100,
    parentStoreId: 100,
    giftCardStoreId: 100,
    posDbaName: 200,
  },
  merchantTerminal: { model: 200, serialNumber: 200, notes: 2000 },
  merchantUser: { name: 200, title: 100, email: 320, phone: 50 },
  emailTemplate: { name: 200, subject: 500 },
  setting: { recipientEmail: 320 },
  partnerForm: {
    firstName: 100,
    middleName: 100,
    lastName: 100,
    dateOfBirth: 40,
    legalName: 200,
    email: 320,
    phone: 40,
    addressLine1: 200,
    city: 100,
    state: 50,
    zip: 20,
    ownershipType: 60,
  },
  import: { name: 150, filename: 400, notes: 1000, mid: 64 },
  default: {
    name: 200,
    code: 30,
    email: 320,
    phone: 50,
    city: 100,
    state: 50,
    zip: 20,
    address: 200,
    description: 500,
    notes: 2000,
  },
} as const;

export function tooLong(label: string, max: number): string {
  return `${label} must not exceed ${max} characters.`;
}
